module.exports = __webpack_public_path__ + "img/rueckrundensieger@2x.1efe8f48.png";